<script setup lang="ts">
import { useRoute } from 'vue-router'
import { onMounted, ref, onUnmounted } from 'vue';
import { ApiConfig } from '@/config/apiConfig'
import { get } from "@/utils/request";
import type { WeatherResponse, Forecast, Cast } from '@/types/weather';

const route = useRoute()

const getTitle = () => {
  return route.path === '/ssc' 
    ? '无锡滨湖区山水城智能网联一期'
    : '国家级江苏（无锡）车联网先导区感知孪生平台'
}

defineOptions({
  name: 'HeaderPage',
});

interface WeatherInfo {
  date: string;
  week: string;
  dayWeather: string;
  nightWeather: string;
  dayTemp: string;
  nightTemp: string;
  dayWind: string;
  nightWind: string;
  dayPower: string;
  nightPower: string;
  weatherIcon: string;
}

const currentTime = ref('');
const currentDate = ref('');
const currentWeekday = ref('');
const weatherInfo = ref<WeatherInfo | null>(null);

const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

const updateDateTime = () => {
  const now = new Date();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');
  currentTime.value = `${hours}:${minutes}:${seconds}`;
  
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  currentDate.value = `${year}.${month}.${day}`;
  
  currentWeekday.value = weekdays[now.getDay()];
};

const fetchWeatherData = async (): Promise<void> => {
  try {
    const mockWeatherData = await get<WeatherResponse>(ApiConfig.weather);
    
    if (!mockWeatherData || !mockWeatherData.forecasts || mockWeatherData.forecasts.length === 0) {
      console.error('天气数据获取失败或数据为空');
      return;
    }

    const forecast = mockWeatherData.forecasts[0].casts[0];
    const weatherText: string = forecast.dayweather || forecast.nightweather;
    
    weatherInfo.value = {
      date: forecast.date,
      week: forecast.week,
      dayWeather: forecast.dayweather,
      nightWeather: forecast.nightweather,
      dayTemp: forecast.daytemp,
      nightTemp: forecast.nighttemp,
      dayWind: forecast.daywind,
      nightWind: forecast.nightwind,
      dayPower: forecast.daypower,
      nightPower: forecast.nightpower,
      weatherIcon: `https://static.chechengzhilian.com/icon_weather/${weatherText}.png`,
    };
    console.log(weatherInfo)
  } catch (error) {
    console.error('获取天气数据失败:', error);
  }
};

let timer: number;

onMounted(() => {
  updateDateTime();
  fetchWeatherData();
  timer = setInterval(updateDateTime, 1000);
});

onUnmounted(() => {
  clearInterval(timer);
});
</script>

<template>
  <div class="header">
    <div class="leftbg"></div>
    <div class="headercenter">
      <div class="title">{{ getTitle() }}</div>
    </div>
    <div class="rightbg">
      <div class="time">
        {{ currentTime }}
      </div>
      <div class="line"></div>
      <div class="dayweek">
        <div class="week"> {{ currentWeekday }}</div>
        <div class="day"> {{ currentDate }}</div>
      </div>

      <img :src="weatherInfo?.weatherIcon" class="img"/>
      <div class="dayweek">
        <div class="week"> {{ weatherInfo?.dayWeather }}</div>
        <div class="day">  {{ weatherInfo?.dayTemp }}℃ ~ {{ weatherInfo?.nightTemp }}℃</div>
      </div>
    
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "./index.scss";
</style>
